export default __webpack_public_path__ + "static/mini-left-angle-477b880a4cf9f9919b7992ec321cd2d9.png";